import React, { useEffect } from 'react';

/**
 * Hayat Design System - Modal Component
 * Phase 15.1
 */

const Modal = ({ 
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  className = '',
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  const sizeStyles = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
  };
  
  return (
    <div 
      className="fixed inset-0 z-modal-backdrop bg-black bg-opacity-50 flex items-center justify-center p-4 animate-fade-in"
      onClick={onClose}
    >
      <div 
        className={`bg-neutral-900/80 backdrop-blur-xl rounded-hayat-lg shadow-hayat-2xl w-full ${sizeStyles[size]} max-h-[90vh] overflow-y-auto animate-slide-up ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        {title && (
          <div className="border-b border-hayat-neutral-200 px-6 py-4 flex justify-between items-center sticky top-0 bg-neutral-900/80 backdrop-blur-xl z-10">
            <h2 className="text-xl font-semibold text-[#F9FAFB]">{title}</h2>
            <button
              onClick={onClose}
              className="text-hayat-neutral-400 hover:text-neutral-500 text-2xl leading-none transition-colors"
            >
              ×
            </button>
          </div>
        )}
        
        {/* Content */}
        <div className="p-6">
          {children}
        </div>
        
        {/* Footer */}
        {footer && (
          <div className="border-t border-hayat-neutral-200 px-6 py-4 bg-neutral-800/50 sticky bottom-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;